import {useQuery} from 'react-query'
import {PaymentMethodEditModalForm} from './PaymentMethodEditModalForm'
import {isNotEmpty, QUERIES} from '../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import {getPaymentMethodById} from '../core/_requests'

const PaymentMethodEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
    isLoading,
    data: paymentmethod,
    error,
  } = useQuery(
    `${QUERIES.USERS_LIST}-paymentmethod-${itemIdForUpdate}`,
    () => {
      return getPaymentMethodById(itemIdForUpdate)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )
  if (!itemIdForUpdate) {
    return <PaymentMethodEditModalForm isPaymentMethodLoading={isLoading} paymentmethod={{id: undefined}} />
  }

  if (!isLoading && !error && paymentmethod) {
    console.log({paymentmethod, },"its paymentmethod")
    console.log(typeof paymentmethod,"its paymentmethod")
    return <PaymentMethodEditModalForm isPaymentMethodLoading={isLoading} paymentmethod={paymentmethod} />
  }

  return null
}

export {PaymentMethodEditModalFormWrapper}
